import { FormType } from '../../../form-types';
import { ZaludYeastInfectionQuestionFieldAnswers } from './questions';

const yeastInfection: FormType<ZaludYeastInfectionQuestionFieldAnswers> = {
  name: 'Yeast Infection Treatment Intake',
  questions: [
    {
      key: 'zalud_yeastInfection_feverChillsPelvicPain',
      next: {
        condition: { 'zalud_yeastInfection_feverChillsPelvicPain.yes': true },
        key: 'zalud_yeastInfection_ineligible',
        els: 'zalud_yeastInfection_abnormalBleeding'
      }
    },
    {
      key: 'zalud_yeastInfection_abnormalBleeding',
      next: {
        condition: { 'zalud_yeastInfection_abnormalBleeding.yes': true },
        key: 'zalud_yeastInfection_ineligible',
        els: 'zalud_yeastInfection_ulcersSores'
      }
    },
    {
      key: 'zalud_yeastInfection_ulcersSores',
      next: {
        condition: { 'zalud_yeastInfection_ulcersSores.yes': true },
        key: 'zalud_yeastInfection_ineligible',
        els: 'zalud_yeastInfection_stiExposure'
      }
    },
    {
      key: 'zalud_yeastInfection_stiExposure',
      next: {
        condition: { 'zalud_yeastInfection_stiExposure.yes': true },
        key: 'zalud_yeastInfection_ineligible',
        els: 'zalud_yeastInfection_recurrentYeast'
      }
    },
    {
      key: 'zalud_yeastInfection_recurrentYeast',
      next: {
        condition: { 'zalud_yeastInfection_recurrentYeast.yes': true },
        key: 'zalud_yeastInfection_ineligible',
        els: 'zalud_yeastInfection_antifungalNoImprovement'
      }
    },
    {
      key: 'zalud_yeastInfection_antifungalNoImprovement',
      next: {
        condition: {
          'zalud_yeastInfection_antifungalNoImprovement.yes': true
        },
        key: 'zalud_yeastInfection_ineligible',
        els: 'zalud_yeastInfection_severeInterference'
      }
    },
    {
      key: 'zalud_yeastInfection_severeInterference',
      next: {
        condition: { 'zalud_yeastInfection_severeInterference.yes': true },
        key: 'zalud_yeastInfection_ineligible',
        els: 'zalud_yeastInfection_symptoms'
      }
    },
    'zalud_yeastInfection_symptoms',
    'zalud_yeastInfection_symptomDuration',
    'zalud_yeastInfection_dischargeDescription',
    'zalud_yeastInfection_dischargeOdor',
    'zalud_yeastInfection_itchingLocation',
    'zalud_yeastInfection_vulvarChanges',
    'zalud_yeastInfection_menstrualCycleTiming',
    'zalud_yeastInfection_antibiotics',
    'zalud_yeastInfection_diabetes',
    'zalud_yeastInfection_newProducts',
    'zalud_yeastInfection_newPartner',
    'zalud_yeastInfection_priorTreatment',
    'zalud_yeastInfection_hormonalContraception',
    'zalud_yeastInfection_menstruating',
    'zalud_yeastInfection_iud',
    'zalud_yeastInfection_confirmedYeast',
    'zalud_yeastInfection_postmenopausal',
    'zalud_yeastInfection_additionalComments',
    {
      key: 'zalud_yeastInfection_consent',
      next: {
        condition: { 'zalud_yeastInfection_consent.proceed': true },
        key: 'zalud_yeastInfection_complete',
        els: 'zalud_yeastInfection_ineligible'
      }
    },
    'zalud_yeastInfection_complete',
    'zalud_yeastInfection_ineligible'
  ]
};

export default yeastInfection;
